import type { CreateDutyInput, DutyScheduleData } from "dutyon-server/types";

export function formatDutyDateKey(value: string | Date) {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
}

export function flattenDutySchedule(scheduleData: DutyScheduleData): CreateDutyInput[] {
  return Object.entries(scheduleData).flatMap(([nurseId, nurseSchedule]) =>
    Object.entries(nurseSchedule).map(([date, entry]) => ({
      nurseId,
      date,
      workShiftId: entry.workShiftId,
    })),
  );
}
